/*eslint-disable*/
import React from "react";
import { Container, Row } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <ul className="nav">
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://everlogbrasil.com.br/"
                target="blank"
              >
                Everlog
              </a>
            </li>{" "}
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://everlogbrasil.com.br/startup-de-logistica/"
                target="blank"
              >
                Empresa
              </a>
            </li>{" "}
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://everlogbrasil.com.br/blog"
                target="blank"
              >
                Blog
              </a>
            </li>
          </ul>
          <div className="copyright">
            © {new Date().getFullYear()} by{" "}
            <a href="https://everlogbrasil.com.br/" target="_blank">
              Everlog
            </a>{" "}
            .
          </div>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
